import Message from './Message.vue'
import Vue from 'vue'

// 通用方法
const message = Vue.extend(Message)
const note = new message().$mount() // 挂载到body


export default note
